// extracted by mini-css-extract-plugin
export default {"wrap":"button_wrap__fuw8x","corner":"button_corner__B1F6r"};